import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AttendanceService {
  options: any;
  serverUrl = environment.apiUrl;
  serverCache = environment.apiUrlCache;

  constructor(
    private _httpClient: HttpClient
  ) { }

  addAttendance(attendanceList: any[], adminId: string): Observable<any> {
    const url = `${this.serverUrl}/addAttendance?adminId=${adminId}`;
    const body = {
      administrator: adminId,
      attendances: attendanceList
    };
    return this._httpClient.post(url, body, this.options);
  }
  
  
  updateAttendance(attendanceUpdates: any[], adminId: string): Observable<any> {
    const url = `${this.serverUrl}/updateAttendance?adminId=${adminId}`;
    const body = {
      administrator: adminId,
      updates: attendanceUpdates
    };
    return this._httpClient.put(url, body, this.options).pipe(
      catchError(error => {
        console.error('Error updating attendance:', error);
        throw error;
      })
    );
  }
  
  addAttendanceByStaff(attendanceList: any[], staffId: string): Observable<any> {
    const url = `${this.serverUrl}/addAttendanceByStaff?staffId=${staffId}`;
    const body = {
      staff: staffId,
      attendances: attendanceList
    };
    return this._httpClient.post(url, body, this.options);
  }
  updateAttendanceByStaff(attendanceUpdates: any[], staffId: string): Observable<any> {
    const url = `${this.serverUrl}/updateAttendanceByStaff?staffId=${staffId}`;
    const body = {
      staff: staffId,
      updates: attendanceUpdates
    };
    return this._httpClient.put(url, body, this.options).pipe(
      catchError(error => {
        console.error('Error updating attendance (staff):', error);
        throw error;
      })
    );
  }
}